module.exports = __webpack_public_path__ + "0698f8564686b2150233dfc5566b21c3.png";